export default __webpack_public_path__ + "static/media/portfolio-163.acea98ff.jpg";